<template>
  <div class="iconStyle" @click="toggleClick">
    <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
  </div>
</template>

<script>
export default {
  name: "",
  props:['isCollapse'],
  data() {
    return {
    };
  },
  methods: {
    toggleClick() {
        this.$emit('toggleClick')
    },
  },
};
</script>

<style lang="less" scoped>
.iconStyle {
  padding: 0 20px 0 0;
  color: #fff;
}
</style>
